import { useSuspenseQuery } from '@apollo/client/react';
import { Row, Space } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useChatSettings } from '@guuru/chat-web';
import NPSButtons from './NpsButtons';
import GET_CHAT_NPS_RATING from './queries/GetChatNPSRating';
import { Headline } from './style';

const ChatNPSRate = function ({ chatId }) {
  const { t } = useTranslation();
  const { data: { chatSettings: { name: partnerName } = {} } = {} } =
    useChatSettings();

  const { data: { chat: { npsRating } = {} } = {} } = useSuspenseQuery(
    GET_CHAT_NPS_RATING,
    { variables: { id: chatId } },
  );

  return (
    <Row justify="center">
      {npsRating === null ? (
        <Space orientation="vertical">
          <Headline>{t('chat:::rateNPSHeadline', { partnerName })}</Headline>
          <NPSButtons chatId={chatId} />
        </Space>
      ) : (
        <Headline>{t('chat:::rateNPSAnswered')}</Headline>
      )}
    </Row>
  );
};

ChatNPSRate.propTypes = {
  chatId: PropTypes.string.isRequired,
};

export default ChatNPSRate;
